import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function ImageDropdown({ options = [], selectedOption, onSelect }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    if (onSelect) {
      onSelect(option);
    }
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Проверяем, что options - это массив, и ищем текущий элемент
  const currentOption =
    (Array.isArray(options) && options.find((opt) => opt.value === selectedOption)) || options[0];

  return (
    <div className="dropdown position-relative" ref={dropdownRef}>
      <button
        className="btn btn-light dropdown-toggle d-flex align-items-center"
        type="button"
        id="dropdownMenuButton"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {/* Проверяем, существует ли currentOption и есть ли у него image */}
        {currentOption?.image && (
          <img
            src={currentOption.image}
            alt={currentOption.label || "Выбранный вариант"}
            style={{
              width: "24px",
              height: "24px",
              objectFit: "contain",
              marginRight: "8px",
            }}
          />
        )}
        {currentOption?.label || "Выберите"}
      </button>

      {open && (
        <ul className="dropdown-menu show"
            aria-labelledby="dropdownMenuButton">
          {options.length > 0 ? (
            options.map((option) => (
              <li key={option.value}>
                <button
                    className="dropdown-item d-flex align-items-center"
                        onClick={() => handleSelect(option.value)}>
                  {/* Проверяем, есть ли у опции изображение */}
                  {option.image && (
                    <img
                      src={option.image}
                      alt={option.label || "Опция"}
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                        marginRight: "8px",
                      }}
                    />
                  )}
                  {option.label}
                </button>
              </li>
            ))
          ) : (
            <li className="text-muted text-center px-3 py-2">Нет данных</li>
          )}
        </ul>
      )}
    </div>
  );
}

export default ImageDropdown;
